




























































































































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import Denuncia from '@/model/Denuncia'
import CargaMagistrado from '@/components/commons/CargaMagistrado.vue'
import CargaExpediente from '@/components/commons/CargaExpediente.vue'
import FechaSelect from '@/components/commons/FechaSelect.vue'
import { showFecha } from '@/utils/DateUtil'
import ShowResoluciones from './ShowResoluciones.vue'
import { KEYS_ESTADO_DENUNCIA, TIPO_COMISION } from '@/api/StaticApi'
@Component({
  components: {
    CargaMagistrado,
    CargaExpediente,
    FechaSelect,
    ShowResoluciones
  }
})
export default class ShowDenuncias extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  @Prop({ default: false, type: Boolean })
  public disabled: boolean

  @Prop({ required: true })
  public denuncia!: Denuncia

  @Prop({ default: false, type: Boolean })
  public loading = false

  @Prop({ type: String })
  public errorMessage

  @Prop({ default: false, type: Boolean })
  public error = false

  generateExpDesc(item: Denuncia) {
    return `Exp. ${item.expediente.resolucion.numero}/${item.expediente.resolucion.anio} - "${item.expediente.caratula}"`
  }
  public localInstance: Denuncia = this.denuncia

  private formDisabled = false

  private dialog = false

  private valid = true

  private estado: KEYS_ESTADO_DENUNCIA | undefined = 'PENDIENTE'

  private get incisoA() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'A')
  }

  private get incisoB() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'B')
  }
  private get incisoC() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'C')
  }
  imprimirComision() {
    return this.localInstance.comision
      ? TIPO_COMISION[this.localInstance.comision]
      : ''
  }
  imprimirIncisos() {
    const incisos: string[] = []
    this.incisoA ? incisos.push('Inciso a)') : ''
    this.incisoB ? incisos.push('Inciso b)') : ''
    this.incisoC ? incisos.push('Inciso c)') : ''
    return incisos.join(' - ')
  }
  private show = true

  showFecha(date: string) {
    return date ? showFecha(date) : ''
  }
  reset() {
    this.$refs.form.reset()
  }
  showMessage() {
    const tipo = this.estado === 'PENDIENTE' ? 'activar' : 'baja'
    this.$emit('showMessage', tipo)
    this.onClose()
  }

  onClose() {
    this.dialog = false
    this.$nextTick(this.reset)
  }
  resetValidation() {
    return true
  }
  validate() {
    return true
  }

  async openDialog(estado?: KEYS_ESTADO_DENUNCIA) {
    await this.onEntidadChange()
    this.estado = estado
    this.dialog = true
  }

  @Watch('denuncia')
  private onEntidadChange() {
    if (this.denuncia) {
      this.localInstance = JSON.parse(JSON.stringify(this.denuncia))
    }
  }
}
